// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var scale = require('./_math-scale');
var fround = require('./_math-fround');

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/es7.math.fscale.js
// module id = 483
// module chunks = 0